import { render, staticRenderFns } from "./question.vue?vue&type=template&id=6e043f7d&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"
import style0 from "./question.vue?vue&type=style&index=0&id=6e043f7d&prod&lang=css"
import style1 from "./question.vue?vue&type=style&index=1&id=6e043f7d&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e043f7d",
  null
  
)

export default component.exports